import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const postConfirmProposals = http.post<object, companyagreementApi.ProposalCreateVariables, object>(
  apiBaseUrl + '/proposals',
  async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000))

    return HttpResponse.json({})
  },
)
